<template>
    <div class="pa-1 ma-1 d-flex flex-row align-center">
        <div class="ma-1" />

        <v-btn ref="createButton" v-if="getCreateButtonExists()" class="mr-1"
            :color="createButtonColor" :class="createButtonCssClass" 
            :dark="createButtonDark"
            :disabled="createButtonDisabled()"
            @click="createButtonClicked()"
            >
            <v-icon>{{createButtonIcon}}</v-icon>
            <span>{{createButtonText}}</span>
        </v-btn>

        <v-btn ref="editButton" v-if="getEditButtonExists()" class="mr-1"
            :color="editButtonColor" :class="editButtonCssClass" 
            :dark="editButtonDark"
            :disabled="editButtonDisabled()"
            @click="editButtonClicked()"
            >
            <v-icon>{{editButtonIcon}}</v-icon>
            <span>{{editButtonText}}</span>
        </v-btn>

        <v-btn ref="saveButton" v-if="getSaveButtonExists()" class="mr-1"
            :color="saveButtonColor" :class="saveButtonCssClass" 
            :dark="saveButtonDark"
            :disabled="saveButtonDisabled()"
            @click="saveButtonClicked()"
            >
            <v-icon>{{saveButtonIcon}}</v-icon>
            <span>{{saveButtonText}}</span>
        </v-btn>

        <v-btn ref="deleteButton" v-if="getDeleteButtonExists()" class="mr-1"
            :color="deleteButtonColor" :class="deleteButtonCssClass" 
            :dark="deleteButtonDark"
            :disabled="deleteButtonDisabled()"
            @click="deleteButtonClicked()"
            >
            <v-icon>{{deleteButtonIcon}}</v-icon>
            <span>{{deleteButtonText}}</span>
        </v-btn>

        <div v-if="getCreateButtonExists()||getEditButtonExists()||getSaveButtonExists()||getEditButtonExists() " class="mx-1" />


        <v-btn ref="stopButton" v-if="getStopButtonExists()" class="mr-1"
            :color="stopButtonColor" :class="stopButtonCssClass" 
            :dark="stopButtonDark"
            :disabled="stopButtonDisabled()"
            @click="stopButtonClicked()"
            >
            <v-icon>{{stopButtonIcon}}</v-icon>
            <span>{{stopButtonText}}</span>
        </v-btn>

        <v-btn ref="restoreButton" v-if="getRestoreButtonExists()" class="mr-1"
            :color="restoreButtonColor" :class="restoreButtonCssClass" 
            :dark="restoreButtonDark"
            :disabled="restoreButtonDisabled()"
            @click="restoreButtonClicked()"
            >
            <v-icon>{{restoreButtonIcon}}</v-icon>
            <span>{{restoreButtonText}}</span>
        </v-btn>

        <div v-if="getStopButtonExists()||getRestoreButtonExists() " class="mx-1" />

        <v-btn ref="auditButton" v-if="getAuditButtonExists()" class="mr-1"
            :color="auditButtonColor" :class="auditButtonCssClass" 
            :dark="auditButtonDark"
            :disabled="auditButtonDisabled()"
            @click="auditpButtonClicked()"
            >
            <v-icon>{{auditButtonIcon}}</v-icon>
            <span>{{auditButtonText}}</span>
        </v-btn>

        <v-btn ref="cancelAuditButton" v-if="getCancelAuditButtonExists()" class="mr-1"
            :color="cancelAuditButtonColor" :class="cancelAuditButtonCssClass" 
            :dark="cancelAuditButtonDark"
            :disabled="cancelAuditButtonDisabled()"
            @click="cancelAuditButtonClicked()"
            >
            <v-icon>{{cancelAuditButtonIcon}}</v-icon>
            <span>{{cancelAuditButtonText}}</span>
        </v-btn>

        <div v-if="getAuditButtonExists()||getCancelAuditButtonExists() " class="mx-1" />

        <v-btn ref="voidButton" v-if="getVoidButtonExists()" class="mr-1"
            :color="voidButtonColor" :class="voidButtonCssClass" 
            :dark="voidButtonDark"
            :disabled="voidButtonDisabled()"
            @click="voidButtonClicked()"
            >
            <v-icon>{{voidButtonIcon}}</v-icon>
            <span>{{voidButtonText}}</span>
        </v-btn>

        <v-btn ref="cancelVoidButton" v-if="getCancelVoidButtonExists()" class="mr-1"
            :color="cancelVoidButtonColor" :class="cancelVoidButtonCssClass" 
            :dark="cancelVoidButtonDark"
            :disabled="cancelVoidButtonDisabled()"
            @click="cancelVoidButtonClicked()"
            >
            <v-icon>{{cancelVoidButtonIcon}}</v-icon>
            <span>{{cancelVoidButtonText}}</span>
        </v-btn>

        <div v-if="getVoidButtonExists()||getCancelVoidButtonExists() " class="mx-1" />

        <v-btn ref="putOnButton" v-if="getPutOnButtonExists()" class="mr-1"
            :color="putOnButtonColor" :class="putOnButtonCssClass" 
            :dark="putOnButtonDark"
            :disabled="putOnButtonDisabled()"
            @click="putOnButtonClicked()"
            >
            <v-icon>{{putOnButtonIcon}}</v-icon>
            <span>{{putOnButtonText}}</span>
        </v-btn>

        <v-btn ref="withdrawButton" v-if="getWithdrawButtonExists()" class="mr-1"
            :color="withdrawButtonColor" :class="withdrawButtonCssClass" 
            :dark="withdrawButtonDark"
            :disabled="withdrawButtonDisabled()"
            @click="withdrawButtonClicked()"
            >
            <v-icon>{{withdrawButtonIcon}}</v-icon>
            <span>{{withdrawButtonText}}</span>
        </v-btn>

        <div v-if="getPutOnButtonExists()||getWithdrawButtonExists() " class="mx-1" />

        <v-btn ref="exportDetailButton" v-if="getExportDetailButtonExists()"  class="mr-1"
            :color="exportDetailButtonColor" :class="exportDetailButtonCssClass" 
            :dark="exportDetailButtonDark"
            :disabled="exportDeatilButtonDisabled()"
            >
            <v-icon>{{exportDetailButtonIcon}}</v-icon>
            <span>{{exportDetailButtonText}}</span>
        </v-btn>

        <div v-if="getExportDetailButtonExists()" class="mx-1" />

        <v-btn ref="cancelEditButton"
            :color="cancelEditButtonColor" :class="cancelEditButtonCssClass"  class="mr-1"
            :dark="cancelEditButtonDark"
            :disabled="cancelEditButtonDisabled()"
            @click="cancelEditButtonClicked">
            <v-icon>{{cancelEditButtonIcon}}</v-icon>
            <span>{{cancelEditButtonText}}</span>            
        </v-btn>

        <v-btn ref="backButton" v-if="getBackButtonExists()"
            :color="backButtonColor" :class="backButtonCssClass" class="mr-1"
            :dark="backButtonDark"
            :disabled="backButtonDisabled()"
            @click="backButtonClicked">
            <v-icon>{{backButtonIcon}}</v-icon>
            <span>{{backButtonText}}</span>            
        </v-btn>

        <div v-if="getBackButtonExists()" class="mx-1" />

        <slot name="append"></slot>
        <!-- 加入插槽 -->
        <!-- 复用的类 引入默认组件，加入插槽 -->
        <!-- 复用方式： -->
        <!-- 1 定义新组件，属性和默认组件一样 -->
        <!-- 2 插入默认组件和插槽，给默认组件传入属性 -->
        <!-- 3 给新增按钮增加监听事件，调用默认组件自定义信号发送出去，新增按钮的状态和默认组件一样处理 -->
    </div>
</template>

<script>
    export default {
        name:'DefaultEditButtonPane',
        props:['context'],
        data () {
            return {

                name:'DefaultEditButtonPane',
                bill:null,
                signals:null,
                menuId:null,

            }
        },
        methods:{

            injectContext(context){
                if(context){
                    if(context.bill)
                        this.bill = context.bill;
                    if(context.signals)
                        this.signals = context.signals;
                }
            },

            initComponent(){
                console.log('EditButtonPane begin init components');

            },
            initSignals(){
                console.log('EditButtonPane begin init signals');
            },
            getSignals(){
                return this.context.signals;
            },
            getMenuId(){
                return this.bill.menuId;
            },
            getModeHelper(){
                return this.context.modeHelper;
            },

            getEditorPane(){
                return this.bill.getEditorPane();
            },

            //-------------------------------
            createButtonClicked(){
                let signal = this.getSignals().newBillAsked;
                signal.dispatch();
            },
            exportDetailClicked(){
                let signal = this.getSignals().exportDetailAsked;
                signal.dispatch();
            },
            cancelEditButtonClicked(){
                let signal = this.getSignals().editCancelAsked;
                signal.dispatch();
            },
            saveButtonClicked(){
                let signal = this.getSignals().saveBillAsked;
                signal.dispatch();
            },
            //-------------------------------

            getCreateButtonExists(){
                return this.getModeHelper().getCreateButtonExists();
            },

            getCreateButtonPermited(){
                return this.getModeHelper().getCreateButtonPermited();
            },

            getEditButtonExists(){
                return this.getModeHelper().getEditButtonExists();
            },

            getEditButtonPermited(){
                return this.getModeHelper().getEditButtonPermited();
            },

            getSaveButtonExists(){
                return this.getModeHelper().getSaveButtonExists();
            },

            getSaveButtonPermited(){
                return this.getModeHelper().getSaveButtonPermited();
            },

            getDeleteButtonExists(){
                return this.getModeHelper().getDeleteButtonExists();
            },

            getDeleteButtonPermited(){
                return this.getModeHelper().getDeleteButtonPermited();
            },

            getAuditButtonExists(){
                return this.getModeHelper().getAuditButtonExists();
            },

            getAuditButtonPermited(){
                return this.getModeHelper().getAuditButtonPermited();
            },

            getCancelAuditButtonExists(){
                return this.getModeHelper().getCancelAuditButtonExists();
            },

            getCancelAuditButtonPermited(){
                return this.getModeHelper().getCancelAuditButtonPermited();
            },

            getVoidButtonExists(){
                return this.getModeHelper().getVoidButtonExists();
            },

            getVoidButtonPermited(){
                return this.getModeHelper().getVoidButtonPermited();
            },

            getCancelVoidButtonExists(){
                return this.getModeHelper().getCancelVoidButtonExists();
            },

            getCancelVoidButtonPermited(){
                return this.getModeHelper().getCancelVoidButtonPermited();
            },


            getPutOnButtonExists(){
                return this.getModeHelper().getPutOnButtonExists();
            },

            getPutOnButtonPermited(){
                return this.getModeHelper().getPutOnButtonPermited();
            },

            getWithdrawButtonExists(){
                return this.getModeHelper().getWithdrawButtonExists();
            },

            getWithdrawVoidButtonPermited(){
                return this.getModeHelper().getWithdrawButtonPermited();
            },

            getExportDetailButtonExists(){
                return this.getModeHelper().getExportDetailButtonExists();
            },

            getExportDetailButtonPermited(){
                return this.getModeHelper().getExportDetailButtonPermited();
            },

            

            getStopButtonExists(){
                return this.getModeHelper().getStopButtonExists();
            },

            getStopButtonPermited(){
                return this.getModeHelper().getStopButtonPermited();
            },

            getRestoreButtonExists(){
                return this.getModeHelper().getRestoreButtonExists();
            },

            getRestoreButtonPermited(){
                return this.getModeHelper().getRestoreButtonPermited();
            },

            getBackButtonExists(){
                return true;
            },

            //button disabled
            //----------------------
            createButtonDisabled(){
                return (!this.getCreateButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing());
            },

            editButtonDisabled(){

                return (!this.getEditButtonPermited())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canEdit())
                || (this.getEditorPane().isEmptyData());
            },

            deleteButtonDisabled(){
                return (!this.getDeleteButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canDelete())
                || (this.getEditorPane().isEmptyData());
            },

            saveButtonDisabled(){
                return (!this.getSaveButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isEditing())
                || (!this.getEditorPane().canSave());
            },

            stopButtonDisabled(){
                return (!this.getStopButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canStop())
                || (this.getEditorPane().isEmptyData());
            },

            restoreButtonDisabled(){
                return (!this.getRestoreButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canRestore())
                || (this.getEditorPane().isEmptyData());
            },

            auditButtonDisabled(){
                return (!this.getAuditButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canAudit())
                || (this.getEditorPane().isEmptyData());
            },

            cancelAuditDisabled(){
                return (!this.getCancelAuditButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canCancelAudit())
                || (this.getEditorPane().isEmptyData());
            },

            putOnButtonDisabled(){
                return (!this.getSaveButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canPutOn());
            },

            withdrawButtonDisabled(){
                return (!this.getSaveButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (!this.getEditorPane().canWithdraw())
                || (this.getEditorPane().isEmptyData());
            },

            exportDetailButtonDisabled(){
                return (!this.getExportDetailButtonPermited())
                || (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing())
                || (this.getEditorPane().isEmptyData());
            },

            cancelEditButtonDisabled(){
                return ((!this.getEditButtonPermited())  && (!this.getCreateButtonPermited()))
                || (!this.getEditorPane())
                || (!this.getEditorPane().isEditing());
            },
            backButtonDisabled(){
                return (!this.getEditorPane())
                || (!this.getEditorPane().isBrowsing());
            },

            //--event--
            //-------------------------------------------------------------
            queryConditionSwitchButtonClicked(){
                let signal = this.getSignals().queryConditionVisiblityChangeAsked;
                signal.dispatch();
            },
            createButtonClicked(){
                let signal = this.getSignals().newBillAsked;
                signal.dispatch();
            },
            backButtonClicked(){
                let signal = this.getSignals().editBackAsked;
                signal.dispatch();
            },
            editButtonClicked(){
                let signal = this.getSignals().editBillAsked;
                signal.dispatch();
            },

            createButtonClicked(){
                let signal = this.getSignals().newBillAsked;
                signal.dispatch();
            },
            exportDetailClicked(){
                let signal = this.getSignals().exportDetailAsked;
                signal.dispatch();
            },
            cancelEditButtonClicked(){
                let signal = this.getSignals().editCancelAsked;
                signal.dispatch();
            },
            saveButtonClicked(){
                let signal = this.getSignals().saveBillAsked;
                signal.dispatch();
            },
            stopButtonClicked(){
                let signal = this.getSignals().stopAsked;
                signal.dispatch();
            },
            restoreButtonClicked(){
                let signal = this.getSignals().restoreAsked;
                signal.dispatch();
            },

        },
        created(){
            console.log("editorButtonPane created");
            this.bill = this.context.bill;
            this.signals = this.context.signals;
            this.initComponent();
            this.initSignals();
        },
        computed:{

            createButtonIcon(){
                return "mdi-file-outline";
            },
            createButtonText(){
                return "新建";
            },
            createButtonCssClass(){
                if(this.getEditButtonExists()||this.getSaveButtonExists()||this.getDeleteButtonExists()){
                    return "left-round";
                }
                return "round";
            },
            createButtonColor(){
                return "primary";
            },
            createButtonDark(){
                return false;
            },

            

            editButtonIcon(){
                return "mdi-notebook-edit-outline";
            },
            editButtonText(){
                return "编辑";
            },
            editButtonCssClass(){
                if(this.getCreateButtonExists()){
                    if(!(this.getSaveButtonExists()||this.getDeleteButtonExists()))
                        return "right-round";
                }else{
                    if((this.getSaveButtonExists()||this.getDeleteButtonExists()))
                        return "left-round";
                    else
                        return "round";    
                }
                
            },
            editButtonColor(){
                return "primary";
            },
            editButtonDark(){
                return false;
            },

            saveButtonIcon(){
                return "mdi-content-save";
            },
            saveButtonText(){
                return "保存";
            },
            saveButtonCssClass(){
                if(this.getCreateButtonExists() || this.getSaveButtonExists()){
                    if(!this.getDeleteButtonExists())
                        return "right-round";
                }else{
                    if(this.getDeleteButtonExists())
                        return "left-round";
                    else
                        return "round";    
                }
                
            },
            saveButtonColor(){
                return "success";
            },
            saveButtonDark(){
                return false;
            },

            deleteButtonIcon(){
                return "mdi-delete-outline";
            },
            deleteButtonText(){
                return "删除";
            },
            deleteButtonCssClass(){
                if(this.getCreateButtonExists() || this.getSaveButtonExists()||this.getDeleteButtonExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            deleteButtonColor(){
                return "red";
            },
            deleteButtonDark(){
                return false;
            },
            //-----------------------------

            stopButtonIcon(){
                return "mdi-stop-circle-outline";
            },
            stopButtonText(){
                return "停用";
            },
            stopButtonCssClass(){
                let whiteText="white--text";
                if(this.getRestoreButtonExists()){
                    return "left-round "+whiteText;
                }else{
                    return "round "+whiteText;    
                }
            },
            stopButtonColor(){
                return "pink";
            },
            stopButtonDark(){
                return false;
            },

            restoreButtonIcon(){
                return "mdi-file-restore";
            },
            restoreButtonText(){
                return "恢复";
            },
            restoreButtonCssClass(){
                if(this.getStopButtonExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            restoreButtonColor(){
                return "pink";
            },
            restoreButtonDark(){
                return false;
            },

            //-----------------------------

            auditButtonIcon(){
                return "mdi-map-check";
            },
            auditButtonText(){
                return "审核";
            },
            auditButtonCssClass(){
                if(this.getCancelAuditButtonExists()){
                    return "left-round";
                }else{
                    return "round";    
                }
            },
            auditButtonColor(){
                return "primary";
            },
            auditButtonDark(){
                return false;
            },

            cancelAuditButtonIcon(){
                return "mdi-cancel";
            },
            cancelAuditButtonText(){
                return "取消审核";
            },
            cancelAuditButtonCssClass(){
                if(this.getAuditButtonExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            cancelAuditButtonColor(){
                return "primary";
            },
            cancelAuditButtonDark(){
                return false;
            },

            //-----------------------------

            voidButtonIcon(){
                return "mdi-store-remove";
            },
            voidButtonText(){
                return "作废";
            },
            voidButtonCssClass(){
                if(this.getCancelVoidButtonExists()){
                    return "left-round";
                }else{
                    return "round";    
                }
            },
            voidButtonColor(){
                return "red";
            },
            voidButtonDark(){
                return false;
            },

            cancelVoidButtonIcon(){
                return "mdi-cancel";
            },
            cancelVoidButtonText(){
                return "作废恢复";
            },
            cancelVoidButtonCssClass(){
                if(this.getVoidButtonExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            cancelVoidButtonColor(){
                return "red";
            },
            cancelVoidButtonDark(){
                return false;
            },

            //-----------------------------

            putOnButtonIcon(){
                return "mdi-cellphone-check";
            },
            putOnButtonText(){
                return "上架";
            },
            putOnButtonCssClass(){
                if(this.getWidthdrawButtonExists()){
                    return "left-round";
                }else{
                    return "round";    
                }
            },
            putOnButtonColor(){
                return "success";
            },
            putOnButtonDark(){
                return false;
            },

            withdrawButtonIcon(){
                return "mdi-cellphone-remove";
            },
            withdrawButtonText(){
                return "下架";
            },
            withdrawButtonCssClass(){
                if(this.getPutOnExists()){
                    return "right-round";
                }else{
                    return "round";    
                }
            },
            withdrawButtonColor(){
                return "success";
            },
            withdrawButtonDark(){
                return false;
            },

            //-----------------------------

            cancelEditButtonIcon(){
                return "mdi-cancel";
            },
            cancelEditButtonText(){
                return "取消";
            },
            cancelEditButtonCssClass(){
                return "left-round white--text";
            },
            cancelEditButtonColor(){
                return "blue-grey";
            },
            cancelEditButtonDark(){
                return false;
            },

            backButtonIcon(){
                return "mdi-arrow-left";
            },
            backButtonText(){
                return "返回";
            },
            backButtonCssClass(){
                return "right-round white--text";
            },
            backButtonColor(){
                return "blue-grey";
            },
            backButtonDark(){
                return false;
            },

            deepCopy(jsonObj){
                return JSON.parse(JSON.stringify(jsonObj));            
            }
            
        }
    }
</script>

</<style>
</style>
